<div
  class="tw-rounded-2xl tw-border tw-border-color-border-subtle tw-bg-color-surface-input tw-shadow-elevation-card"
  data-testid="account-linked-collection"
>
  <app-widget [backgroundClass]="'tw-bg-color-surface-input'" [hideIcon]="true">
    <div class="tw-flex tw-min-w-0 sm:tw-flex-wrap tw-items-center tw-gap-2 tw-pb-2">
      <span
        class="tw-text-lg tw-font-medium tw-uppercase tw-text-color-text-secondary sm:tw-text-sm"
      >
        {{ "sharing" | i18n }}
      </span>
      <div class="tw-ml-auto tw-shrink-0">
        <app-gloss-button
          [options]="{
            text: 'shareWithTeam' | i18n,
            isEnabled: true,
            onClick: shareWithTeam.emit.bind(shareWithTeam),
            class: 'syncButton',
            testId: 'share-with-team',
          }"
        ></app-gloss-button>
      </div>
    </div>

    @if (rows.length > 0) {
      <div class="tw-mt-3 tw-flex tw-flex-col tw-gap-2" data-testid="shared-team-rows">
        @for (row of rows; track row.collectionId) {
          <div
            class="tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-bg-color-surface-sunken tw-px-[14px] tw-py-3"
            data-testid="shared-team-row"
          >
            <div
              class="tw-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-color-surface-brand tw-text-[13px] tw-font-semibold tw-text-color-intent-brand"
            >
              {{ row.initial }}
            </div>
            <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-0.5">
              <span class="tw-truncate tw-text-[13px] tw-font-semibold tw-text-color-text-default">
                {{ row.name }}{{ row.membersLabel ? " · " + row.membersLabel : "" }}
              </span>
              <span class="tw-truncate tw-text-[11px] tw-font-medium tw-text-color-text-tertiary">
                {{ "sharingLiveSubtitle" | i18n }}
              </span>
            </div>
            <span
              class="tw-inline-flex tw-h-7 tw-min-w-[60px] tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-color-status-success-bg tw-px-2 tw-text-[13px] tw-font-medium tw-text-color-status-success-text"
            >
              {{ "sharingStatusLive" | i18n }}
            </span>
          </div>
        }
      </div>
    } @else {
      <p class="tw-text-xs tw-text-color-text-secondary">
        {{ "sharingDescription" | i18n }}
      </p>
    }
  </app-widget>
</div>
